import SceneObjectTypeData from "./SceneObjectTypeData";
import ChecklistItemTypeData from "./ChecklistItemTypeData";
import apiSceneObjectTypeDataSchema from "../../services/bimVisualizerApi/schema/document/sceneObject/apiSceneObjectTypeDataSchema";

const createSceneObjectTypeData = (raw: unknown): SceneObjectTypeData | null => {
    if (raw === null || raw === undefined) {
        return null;
    }

    const parsed = apiSceneObjectTypeDataSchema.parse(raw);

    switch (parsed.sceneObjectType) {
        case "ChecklistItem":
            return new ChecklistItemTypeData(parsed.checklistItemId, parsed.imageUrl, parsed.color);
    }
};

export default createSceneObjectTypeData;
